import React, { useState } from 'react';
import PropTypes           from 'prop-types';
import AuthModal           from './AuthModal';
import './AuthLanding.scss';

export default function AuthLanding({ onAuthSuccess }) {
  const [mode, setMode] = useState(null);   // 'login' | 'create' | null

  return (
    <div className="auth-landing">
      {!mode && (
        <>
          <button className="ghost-btn" onClick={() => setMode('login')}>
            LOG&nbsp;IN
          </button>

          <span className="or">or</span>

          <button className="ghost-btn" onClick={() => setMode('create')}>
            CREATE&nbsp;ACCOUNT
          </button>
        </>
      )}

      {mode && (
        <AuthModal
          mode={mode}
          onClose={() => setMode(null)}
          onSuccess={() => {
            onAuthSuccess();     // notify App.js
            setMode(null);
          }}
        />
      )}
    </div>
  );
}

AuthLanding.propTypes = { onAuthSuccess: PropTypes.func.isRequired };
